import FlightCardSkeleton from './FlightCardSkeleton';

export default FlightCardSkeleton;
